import { render, staticRenderFns } from "./PdfPreview.vue?vue&type=template&id=64e6308a&scoped=true&"
import script from "./PdfPreview.vue?vue&type=script&lang=ts&"
export * from "./PdfPreview.vue?vue&type=script&lang=ts&"
import style0 from "./PdfPreview.vue?vue&type=style&index=0&id=64e6308a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6308a",
  null
  
)

export default component.exports